var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(
      _vm.fullscreenLoading && _vm.chatStore.chats && _vm.chatStore.chats.length
    ),expression:"\n      fullscreenLoading && chatStore.chats && chatStore.chats.length\n    ",modifiers:{"fullscreen":true,"lock":true}}]},[_c('el-container',{staticClass:"r-chat-box"},[(_vm.flagByContentBox && _vm.isShowFlag)?_c('chat-box',{attrs:{"chat":_vm.activeChat,"yesuser":true}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }